export const SHARED_CART_ITEM_PLACEHOLDER_ID = 'optimistic-client-side-shared-cart-item';
